export const carouselData = {
  golf: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/jw-mrkfl-golf-putt-close-22563?wid=516&fit=constrain",
        title: "Popular Golf Resorts",
        description: "Stay and play at some of our finest golf resorts.",
        buttonLink: "https://www.marriott.com/en-us/resorts/golf-resorts",
      },
      {
        image:
          "https://www.marriott.com/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1257262565-34805.jpg",
        title: "Marriott Bonvoy Moments",
        description:
          "Enjoy your favorite game, meet legends and sharpen your skills.",
        buttonLink:
          "https://moments.marriottbonvoy.com/en-us/moments/category/sports",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/rz-hnlkz-golf-738776123-21226?wid=516&fit=constrain",
        title: "Golf Experiences",
        description: "Discover golf experiences near and far.",
        buttonLink: "https://activities.marriott.com/search?term=golf",
      },
    ],
  },
  culture: {
    slides: [
      {
        image:
          "https://www.marriott.com/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-adobestock-186310170-16291.jpeg",
        title: "Marriott Bonvoy Moments™",
        description:
          "Attend premiers, galas, cultural excursions and exclusive events",
        buttonLink:
          "https://moments.marriottbonvoy.com/en-us/moments/category/arts-lifestyle",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/br-huzbr-dong-ping-art-20156?wid=516&fit=constrain",
        title: "Connect to Culture",
        description: "Find travel inspiration centered on culture and style.",
        buttonLink: "https://activities.marriott.com/activities?term=culture",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/jw-chijw-the-art-institute-42639?wid=516&fit=constrain",
        title: "Immerse Yourself in Art",
        description: "Book memorable experiences focused on arts and culture.",
        buttonLink:
          "https://traveler.marriott.com/culture-and-style/art-and-museums/",
      },
    ],
  },
  culinary: {
    slides: [
      {
        image:
          "https://www.marriott.com/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1424166516-20001.jpg",
        title: "Marriott Bonvoy Moments™",
        description:
          "Bid Marriott Bonvoy Points on curated wine tastings, cooking classes & more.",
        buttonLink:
          "https://moments.marriottbonvoy.com/en-us/moments/category/culinary",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/eb-madeb-market-at-edition-41996?wid=516&fit=constrain",
        title: "Culinary Experiences",
        description:
          "Be inspired by global dining at destinations for every taste.",
        buttonLink:
          "https://traveler.marriott.com/eat-and-drink/culinary-experiences/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/xr-kulxr-cocktail-motion-10844?wid=516&fit=constrain",
        title: "Indulge in Elevated Sips",
        description: "Discover craft cocktails worth traveling for",
        buttonLink: "https://traveler.marriott.com/eat-and-drink/bars/",
      },
    ],
  },
  spa: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-530719465?wid=316&fit=constrain",
        title: "Spa Resorts",
        description: "Replenish and rest in a wellness focused getaway.",
        buttonLink: "https://www.marriott.com/en-us/resorts/spa-resorts.mi",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/br-phxbd-day-spa-24072?wid=516&fit=constrain",
        title: "Discover Top Spas",
        description: "Find bliss at the world’s best spa resorts.",
        buttonLink: "https://traveler.marriott.com/spa/worlds-best-hotel-spas/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/rz-ejhrz-yoga-pavilion-31557-82785?wid=516&fit=constrain",
        title: "Relax and Replenish",
        description: "Realign mind, body, and spirit with mindful travel.",
        buttonLink: "https://traveler.marriott.com/wellness/mindful-travel/",
      },
    ],
  },
  beach: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/mv-hnlpw-waikiki-beach-13761?wid=516&fit=constrain",
        title: "Escape the Everyday",
        description: "Seek sun and sand at our top beach destinations.",
        buttonLink:
          "https://traveler.marriott.com/mindful-travel/reconnect-travel-us-caribbean/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/jw-mrkfl-mrkfl-paddleboard41755-72882?wid=516&fit=constrain",
        title: "Beach Tours & Activities",
        description:
          "Explore exciting excursions, water sport lessons and other curated adventures.",
        buttonLink: "https://activities.marriott.com/activities?term=beach",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-whale-bar-aerial-37919-47743?wid=516&fit=constrain",
        title: "Paradise is Calling",
        description: "Find relaxation and wellness on the shore",
        buttonLink:
          "https://traveler.marriott.com/outdoor-activities/beach-travel/",
      },
    ],
  },
  music: {
    slides: [
      {
        image:
          "https://www.marriott.com/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1464095590-29450.jpg",
        title: "Marriott Bonvoy Moments™",
        description:
          "Get show-stopping access to epic concerts, music festivals and more.",
        buttonLink:
          "https://moments.marriottbonvoy.com/en-us/moments/category/entertainment",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/mc-tricc-girls-at-music-festival--16205?wid=516&fit=constrain",
        title: "Top Music Festivals",
        description:
          "Bringing together some of the best entertainers, performers and creative minds, these 7 festivals are well worth traveling for.",
        buttonLink:
          "https://traveler.marriott.com/culture-and-style/top-music-festivals/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/wh-miaws-live-music-35312?wid=516&fit=constrain",
        title: "Ultimate Music Destinations",
        description: "Connect with favorite artists and immerse in live music",
        buttonLink: "https://w-hotels.marriott.com/w-presents/",
      },
    ],
  },
  ski: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/tx-szgjf-skiing-40984?wid=516&fit=constrain",
        title: "Snowbound Thrills",
        description:
          "Discover slopeside stays and carve through winter's best runs.",
        buttonLink:
          "https://www.marriott.com/en-us/outdoors/skiing-and-snowboarding",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-637078978?wid=516&fit=constrain",
        title: "Top Ski Resorts",
        description: "Seek snowy peaks at these amazing destinations.",
        buttonLink:
          "https://traveler.marriott.com/hotel-experiences/best-cold-weather-resorts/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-485977037?wid=516&fit=constrain",
        title: "Find Chill Thrills",
        description: "Find your next cold-weather escape.",
        buttonLink:
          "https://traveler.marriott.com/outdoor-activities/skiing-and-snowboarding/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/wh-asewh-ski-trail-24804?wid=516&fit=constrain",
        title: "Epic Winter Sports",
        description:
          "Spend winter exploring these nine national parks by skiing, snowshoeing, cross-country skiing and even dog-sledding.",
        buttonLink:
          "https://traveler.marriott.com/national-parks/national-parks-winter-sports/",
      },
    ],
  },
  "am-drinks": {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/jw-chijw-breakfast-coffee-42639?wid=516&fit=constrain",
        title: "Morning Coffee Experiences",
        description:
          "Start your day with premium coffee at our finest properties.",
        buttonLink: "https://www.marriott.com/en-us/hotels/hotel-search.mi",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/mc-tricc-breakfast-buffet-16205?wid=516&fit=constrain",
        title: "Breakfast Dining",
        description: "Discover exceptional breakfast experiences at Marriott.",
        buttonLink: "https://www.marriott.com/en-us/hotels/hotel-search.mi",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/br-huzbr-juice-bar-20156?wid=516&fit=constrain",
        title: "Fresh Juice & Smoothies",
        description: "Energize your morning with fresh, healthy beverages.",
        buttonLink: "https://www.marriott.com/en-us/hotels/hotel-search.mi",
      },
    ],
  },
  "afternoon-drinks": {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/xr-kulxr-pool-bar-10844?wid=516&fit=constrain",
        title: "Poolside Refreshments",
        description: "Cool down with refreshing drinks by the pool.",
        buttonLink: "https://www.marriott.com/en-us/hotels/hotel-search.mi",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/eb-madeb-lobby-bar-41996?wid=516&fit=constrain",
        title: "Afternoon Tea Service",
        description: "Experience elegant afternoon tea traditions.",
        buttonLink: "https://www.marriott.com/en-us/hotels/hotel-search.mi",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/wh-miaws-lounge-35312?wid=516&fit=constrain",
        title: "Sparkling Water Bar",
        description: "Stay hydrated with premium sparkling water selections.",
        buttonLink: "https://www.marriott.com/en-us/hotels/hotel-search.mi",
      },
    ],
  },
  "evening-drinks": {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/xr-kulxr-cocktail-motion-10844?wid=516&fit=constrain",
        title: "Craft Cocktails",
        description: "Discover craft cocktails worth traveling for.",
        buttonLink: "https://traveler.marriott.com/eat-and-drink/bars/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/wh-asewh-wine-bar-36556?wid=516&fit=constrain",
        title: "Wine Collections",
        description: "Explore curated wine selections from around the world.",
        buttonLink: "https://www.marriott.com/en-us/hotels/hotel-search.mi",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/jw-mrkfl-bar-lounge-22563?wid=516&fit=constrain",
        title: "Evening Lounges",
        description: "Unwind with evening beverages in sophisticated settings.",
        buttonLink: "https://www.marriott.com/en-us/hotels/hotel-search.mi",
      },
    ],
  },
  fish: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-fishing-32864?wid=516&fit=constrain",
        title: "Hooked on the Moment",
        description: "Find peaceful waters and reel in your next great escape.",
        buttonLink: "https://www.marriott.com/en-us/outdoors/fishing",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1179787384?wid=516&fit=constrain",
        title: "Reel in Serenity & Sport",
        description:
          "Reel in big catches at stunning global fishing destinations.",
        buttonLink:
          "https://traveler.marriott.com/watersports/best-places-to-fish/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1337989734?wid=516&fit=constrain",
        title: "Hooked on Adventure",
        description:
          "From lakes to oceans, explore the best places to cast off.",
        buttonLink:
          "https://traveler.marriott.com/united-states/best-lakeside-resorts/",
      },
    ],
  },
  surf: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-surfing-35181?wid=516&fit=constrain",
        title: "Catch the Wave",
        description: "Surf top breaks and stay steps from the shoreline.",
        buttonLink: "https://www.marriott.com/en-us/outdoors/surfing",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-507006402?wid=516&fit=constrain",
        title: "Surf the Hottest Swells",
        description: "Catch thrilling waves in legendary beach destinations.",
        buttonLink:
          "https://traveler.marriott.com/watersports/best-places-to-surf/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1314586365?wid=516&fit=constrain",
        title: "Board, Beach, Bliss",
        description: "Ride the world’s best swells in exotic surf havens.",
        buttonLink:
          "https://traveler.marriott.com/indonesia/carve-waves-hottest-bali-surf-spots/",
      },
    ],
  },
  bike: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-biking-23977?wid=516&fit=constrain",
        title: "Pedal to Adventure",
        description:
          "Explore scenic routes and bike-friendly stays across the map.",
        buttonLink: "https://www.marriott.com/en-us/outdoors/biking",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-916255624?wid=516&fit=constrain",
        title: "Trails Are Calling",
        description: "Pedal through landscapes built for adventure seekers.",
        buttonLink:
          "https://traveler.marriott.com/hiking-and-biking/best-cycling-vacations/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-555000999?wid=516&fit=constrain",
        title: "Ride Into Adventure",
        description: "Mountain biking thrills in stunning natural settings.",
        buttonLink:
          "https://traveler.marriott.com/hiking-and-biking/best-places-to-mountain-bike/",
      },
    ],
  },
  hike: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-hiking-25290?wid=516&fit=constrain",
        title: "Wander & Unwind",
        description:
          "Hike wild trails by day, glamp in luxury under the stars.",
        buttonLink:
          "https://www.marriott.com/en-us/outdoors/camping-and-hiking",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1056063176?wid=516&fit=constrain",
        title: "Elevate Your Escape",
        description: "Hike epic paths, then relax in stylish outdoor stays.",
        buttonLink:
          "https://traveler.marriott.com/hiking-and-biking/best-places-to-hike/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/oc-summer-hike-in-montana-23036?wid=516&fit=constrain",
        title: "Explore Breathtaking Sights",
        description: "Find scenic trails and endless views.",
        buttonLink:
          "https://traveler.marriott.com/hiking-and-biking/best-hikes-in-world/",
      },
    ],
  },
  paddle: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-kayaking-18589?wid=516&fit=constrain",
        title: "Paddle Your Own Path",
        description:
          "Glide through calm waters with stays near serene rivers & lakes.",
        buttonLink:
          "https://www.marriott.com/en-us/outdoors/kayaking-and-canoeing",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1281848693?wid=516&fit=constrain",
        title: "Flow Into Nature",
        description: "Kayak scenic routes surrounded by natural beauty.",
        buttonLink:
          "https://traveler.marriott.com/watersports/best-places-to-kayak/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1257426806?wid=516&fit=constrain",
        title: "Chart Your Course",
        description: "Glide through serene waters and untouched landscapes.",
        buttonLink:
          "https://traveler.marriott.com/greece/watersports-costa-navarino-greece/",
      },
    ],
  },
  dive: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-diving-41476?wid=516&fit=constrain",
        title: "Dive Into Wonder",
        description:
          "Stay near crystal waters and explore vibrant marine life.",
        buttonLink:
          "https://www.marriott.com/en-us/outdoors/snorkeling-and-scuba-diving",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1142861831?wid=516&fit=constrain",
        title: "Explore the World Beneath",
        description: "Uncover hidden depths in top diving destinations.",
        buttonLink:
          "https://traveler.marriott.com/watersports/best-places-to-dive/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1130867214?wid=516&fit=constrain",
        title: "Escape Under the Sea",
        description: "Dive into coral kingdoms and vibrant marine life zones.",
        buttonLink:
          "https://traveler.marriott.com/caribbean-latin-america/bvi-scuba-diving-snorkeling/",
      },
    ],
  },
  safari: {
    slides: [
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-154891670?wid=516&fit=constrain",
        title: "Go Beyond",
        description: "Choose your path through unforgettable safari terrain.",
        buttonLink:
          "https://traveler.marriott.com/safari/alternative-african-safari-tours/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-83389523?wid=516&fit=constrain",
        title: "Walk on the Wild Side",
        description: "Spot iconic animals across vast, untamed landscapes.",
        buttonLink:
          "https://traveler.marriott.com/safari/hotel-outdoor-experiences/",
      },
      {
        image:
          "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-2158798075?wid=516&fit=constrain",
        title: "Your Safari Awaits",
        description: "Journey through Africa’s most majestic wildlife zones.",
        buttonLink:
          "https://traveler.marriott.com/safari/east-africa-ultimate-destination/",
      },
    ],
  },
};
